import React, { useState, useEffect } from "react";
import useAuthState from "../auth/useAuthState.js";
import { AccommodationIcon } from "../accommodation/AccommodationIcon.tsx";
import { BOOK_DATE_FORMAT } from "./BookConstant.ts";
import format from "date-fns/format";
import useBookState from "./useBookState.ts";
import Book from "./Book";
import usePaymentState from "../payments/usePaymentState.ts";
interface BookPaidAndDeletedListProps {
    //token: string;
    //onCancel: () => void;
    openDetailPannel: (id: number) => void;
}

export const BookPaidAndDeletedList: React.FC<BookPaidAndDeletedListProps> = ({ openDetailPannel }: BookPaidAndDeletedListProps) => {
    const { token, getToken } = useAuthState();
    const { book_list, getPaidAndDeletedList } = useBookState();
    const [showRefundPopup, setShowRefundPopup] = useState<boolean>(false);
    const [selectedBook, setSelectedBook] = useState<Book | null>(null);
    const [refundAmount, setRefundAmount] = useState<number>(0);
    const { payment, updateRefund } = usePaymentState();

    useEffect(() => {
        if (token) getPaidAndDeletedList(token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (payment && token) {
            getPaidAndDeletedList(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payment]);

    const handleRefundClick = (book: Book) => {
        setSelectedBook(book);
        setRefundAmount(book.price); // デフォルトで元の価格を設定
        setShowRefundPopup(true);
    };

    const handleRefundSubmit = () => {
        if (selectedBook && token) {
            // TODO: 返金処理のAPIを呼び出す

            updateRefund(token, selectedBook.id, refundAmount);

            // ポップアップを閉じる
            setShowRefundPopup(false);
            setSelectedBook(null);
            setRefundAmount(0);
        }
    };

    const handleRefundCancel = () => {
        setShowRefundPopup(false);
        setSelectedBook(null);
        setRefundAmount(0);
    };
    return (
        <>
            {book_list ? (
                <div className="toggle-pannel-header">
                    <div className="toggle-title">要返金リスト</div>
                </div>
            ) : null}
            <div className="item-list-item header">
                <div className="w80 accommodation">施設</div>
                <div className="w130">宿泊日</div>
                <div className="free">宿泊者</div>
                <div className="w100 wide-hidden">支払い金額</div>
                <div className="w130">予約発生日</div>
                <div className="button wide-hidden">詳細</div>
                <div className="button wide-hidden">返金</div>
            </div>
            {book_list
                ? book_list.map((book) => {
                      return (
                          <div className="mail-list-item">
                              <div className="w80 accommodation">
                                  {book.accommodation_id && token ? <AccommodationIcon token={token} id={book.accommodation_id} /> : null}
                              </div>
                              <div className="w130">{format(book.start_date, BOOK_DATE_FORMAT)}</div>
                              <div className="free">{book.name}</div>
                              <div className="w100 wide-hidden">{book.price.toLocaleString()}円</div>
                              <div className="w130">{format(book.created_at, BOOK_DATE_FORMAT)}</div>

                              <div className="button wide-hidden">
                                  <button onClick={() => openDetailPannel(book.book_id)} className="link">
                                      詳細
                                  </button>
                              </div>
                              <div className="button wide-hidden">
                                  <button onClick={() => handleRefundClick(book)} className="link">
                                      返金済み
                                  </button>
                              </div>
                          </div>
                      );
                  })
                : null}

            {/* 返金ポップアップ */}
            {showRefundPopup && selectedBook && (
                <div
                    className="popup-overlay"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        className="popup-content"
                        style={{
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "8px",
                            maxWidth: "400px",
                            width: "90%",
                        }}
                    >
                        <h3 style={{ marginBottom: "20px", marginTop: "0" }}>返金処理</h3>
                        <div style={{ marginBottom: "25px" }}>
                            <p style={{ marginBottom: "8px" }}>
                                <strong>宿泊者:</strong> {selectedBook.name}
                            </p>
                            <p style={{ marginBottom: "8px" }}>
                                <strong>宿泊日:</strong> {format(selectedBook.start_date, BOOK_DATE_FORMAT)}
                            </p>
                            <p style={{ marginBottom: "8px" }}>
                                <strong>支払金額:</strong> {selectedBook.price.toLocaleString()}円
                            </p>
                        </div>

                        <div style={{ marginBottom: "25px" }}>
                            <label htmlFor="refundAmount" style={{ display: "block", marginBottom: "8px" }}>
                                <strong>返金金額:</strong>
                            </label>
                            <input
                                id="refundAmount"
                                type="number"
                                value={refundAmount}
                                onChange={(e) => setRefundAmount(Number(e.target.value))}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "16px",
                                }}
                                max={selectedBook.price}
                                min={0}
                            />
                            <small style={{ color: "#666", display: "block", marginTop: "8px", fontSize: "12px" }}>
                                最大 {selectedBook.price.toLocaleString()}円まで
                            </small>
                        </div>

                        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "30px" }}>
                            <button
                                onClick={handleRefundCancel}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #ccc",
                                    backgroundColor: "white",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                キャンセル
                            </button>
                            <button
                                onClick={handleRefundSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "none",
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                                disabled={refundAmount <= 0 || refundAmount > selectedBook.price}
                            >
                                返金登録
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
